import { render, staticRenderFns } from "./academic-analysis.vue?vue&type=template&id=16585d18&scoped=true"
import script from "./academic-analysis.vue?vue&type=script&lang=js"
export * from "./academic-analysis.vue?vue&type=script&lang=js"
import style0 from "./academic-analysis.vue?vue&type=style&index=0&id=16585d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16585d18",
  null
  
)

export default component.exports